// Keep in sync with Models/SpotTags.cs on the backend — see REFACTOR_PLAN.md.
export const AVAILABLE_TAGS = [
  // Activities
  'Hiking',
  'Mountain Biking',
  'Skiing',
  'Snowboarding',
  'Snowmobiling',
  'Off-Roading',
  'Paddling',
  'Fishing',
  'Swimming',
  'Bouldering',
  'Climbing',
  // Camping
  'Car Camping',
  'Wilderness Camping',
  // Nature features
  'Wildlife Viewing',
  'Waterfall',
  'Hot Spring',
  // Scenic / conditions
  'Scenic View',
  'Scenic Drive',
  'Dark Sky',
  'No Cell Service',
  // Food & drink
  'Food',
  'Beer',
  'Winery',
  'Other',
];
